import Button from './Button';
import { defaultButtonStyles } from './Button.styles';

export { defaultButtonStyles };
export default Button;
